module.exports = __webpack_public_path__ + "img/light.0a04e240.gif";